import React from "react";

/**
 * The assistant's identity mark.
 *
 * A node inside a diamond: TNSPay IQ answers questions about payments and
 * connectivity, so the mark is a point on a network rather than a generic
 * robot or sparkle. Sits at the left of every assistant turn, which is what
 * gives the transcript its speaker rhythm without needing bubbles.
 */
export default function AssistantMark({ size = 28, busy = false, className = "" }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-[9px] bg-iq-brand text-white ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        width={Math.round(size * 0.6)}
        height={Math.round(size * 0.6)}
        viewBox="0 0 16 16"
        fill="none"
        className={busy ? "animate-iq-breathe" : undefined}
      >
        <path
          d="M8 1.5 14.5 8 8 14.5 1.5 8 8 1.5Z"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinejoin="round"
        />
        <circle cx="8" cy="8" r="2.05" fill="currentColor" />
      </svg>
    </span>
  );
}
